// extracted by mini-css-extract-plugin
export default {"h_divider":"Divider_h_divider__M2bB2","shadow":"Divider_shadow__OhN+t","text":"Divider_text__48gUE","text2":"Divider_text2__cJRi9"};